import { BaseMutations } from '@/store/base-mutations';
import { Contacts, SendAppeal } from '../types';
import ContactsState from './state';

export default class ContactsMutations extends BaseMutations<ContactsState> {
  SET_CARDS(items: Contacts.Card[]) {
    this.state.cards = items;
  }

  SET_CARD_ITEMS(items: Contacts.CardItems[]) {
    this.state.card_items = items;
  }

  UPD_APPEAL_KEY({ key, value }: { key: keyof SendAppeal, value: unknown }) {
    this.state.appeal_payload[key] = value;
  }

  CLEAR_APPEAL() {
    this.state.appeal_payload = {
      title: '',
      description: '',
      mail_to: '',
      files: [],
    };
    this.state.uploaded_files = [];
  }

  WHEN_OPEN_MODAL() {
    this.state.appeal_payload.files = this.state.uploaded_files;
  }

  UPD_FILES(item: File) {
    this.state.uploaded_files.push(item);
  }

  REMOVE_FILE(index: number) {
    if (this.state.appeal_payload.files) {
      this.state.appeal_payload.files.splice(index, 1);
    }
  }
}
